<script>

    import { toast } from 'bulma-toast'
    import { pricingsStore, modalStore } from '../stores'

    import PricingsService from '../$services/pricings.service'

    import Form from '../$components/form.svelte'
    import Save from '../$components/button.save.svelte'
    import Cancel from '../$components/button.cancel.svelte'
    import InputText from '../$components/input.text.svelte'
    import InputNumber from '../$components/input.number.svelte'

    import Providers from '../$components/providers.svelte'

    let loading = false
    let data = {}
    
    async function createPricing() {
    
        loading = true
        const resp = await PricingsService.createPricing(data)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
    
        pricingsStore.append(resp.data)
        modalStore.close()
    }

</script>

<Form on:submit={createPricing} {loading} >
    
    <div class="columns">
        <div class="column">
            <Providers bind:provider={data.provider} bind:service={data.service} />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.volumetricMin} label="Peso mínimo" placeholder="Peso mínimo" min="0" step="0.1" />
        </div>
        <div class="column">
            <InputNumber bind:value={data.volumetricMax} label="Peso máximo" placeholder="Peso máximo" min="0" step="0.1" />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.shipmentCost} label="Costo" placeholder="Costo" />
        </div>
        <div class="column">
            <InputNumber bind:value={data.shipmentPrice} label="Precio" placeholder="Precio" step="0.1" />
        </div>
    </div>

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <div class="buttons">
            <Cancel on:click={modalStore.close} />
            <Save />
        </div>
    </div>

</Form>